
















import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from 'vuex-class';
@Component
export default class GroupActivitySection extends Vue {
  @Getter("mainTextColor")
  mainTextColor!: string;
  @Prop({ required: true })
  title!: string;
}
